<template>
  <div class="FormFormulario">
    <div id="FormFormulario">
      <form-wizard
        @on-complete="onComplete"
        next-button-text="Siguiente"
        back-button-text="Regresar"
        finish-button-text="Consultar"
        title
        subtitle
        
      >
        <tab-content
          :title="this.labelFields.fields1"
          icon="ti-target"
          :before-change="beforeTabSwitch1"
        >
          <div class="container">
            <div class="row content">
              <div class="col totalform">
                <ValidationObserver ref="obsFields1">
                  <Formulario
                    :FieldsForm="Formulario.fields1"
                    :ModelForm="formInsModel"
                    :method="executeProcess"
                  />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import Formulario from "@/components/Forms.vue";
import IberoHelpers from "@/store/helpers.js";

export default {
  name: "FormFormulario",
  components: {
    Formulario
  },
  methods: {
    dataObjCheck: function(InfDaT) {
      if (InfDaT === true) {
        return this.$ml.get("Accepted");
      }
      return this.$ml.get("NotAccepted");
    },
    dataformat: function(InfDaT) {
      return IberoHelpers.dataObjDate(InfDaT);
    },
    dataObjFindJs: function(infoDaT, FinDaT) {
      return IberoHelpers.dataObjFind(infoDaT, FinDaT);
    },
    executeProcess: function(event) {
      console.log(event.target.id);
      switch (event.target.id) {
      }
    },
    onComplete: function() {
      var resultDIplo = IberoHelpers.getDiplomas(
        this.$store.state.ApiIbero.WSUtilitary,
        this.$store.state.sDiplomas,
        this.formInsModel.IdDocumento,
        this.formInsModel.IdEmail
      );
      resultDIplo.then(Response => {
        var sTable =
          "<div class='alert alert-success' role='alert'>" +
          "No tiene diplomas disponibles." +
          "</div> ";
        if (Response.data != "") {
          sTable =
            "<table class='table table-hover' id='myTable2' ref='table'>" +
            "       <thead>" +
            "         <tr>" +
            "           <th scope='col'>Estudiante</th>" +
            "           <th scope='col'>Curso</th>" +
            "           <th scope='col'>Estado</th>" +
            "           <th scope='col'>Link</th>" +
            "         </tr>" +
            "       </thead>" +
            "       <tbody> ";

          for (var i = 0; i < Response.data[0].Courses.length; i++) {
            sTable +=
              "<tr> <td>" +
              Response.data[0].Student +
              "</td>" +
              "<td>" +
              Response.data[0].Courses[i].Course +
              "</td>" +
              "<td>" +
              Response.data[0].Courses[i].CourseStatus +
              "</td>" +
              "<td><a href='" +
              Response.data[0].Courses[i].FileUrl +
              "' target='_blank'>Descargar</a></tr>";
          }
          sTable += "</tbody> </table>";
        }
        this.Formulario.fields1[2].values = sTable;
      });
    },
    beforeTabSwitch1: function() {
      return new Promise((resolve, reject) => {
        this.$refs.obsFields1.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 500);
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },
    beforeTabSwitch2: function() {},
    beforeTabSwitch3: function() {}
  },
  created() {},
  data() {
    return {
      labelFields: {
        fields1: "",
        fields2: "",
        fields3: "",
        fields4: ""
      },
      formInsModel: {
        Campaign: this.$route.params.referencia,
        IdDocumento: "",
        IdEmail: ""
      },
      Formulario: {
        fields1: [
          {
            id: "IdDocumento",
            model: "IdDocumento",
            name: "Buscar por número de documento",
            type: "input",
            placeholder: "Documento",
            values: "",
            validate: {
              required: false
            },
            class: "col-md-6"
          },
          {
            id: "IdEmail",
            model: "IdEmail",
            name: "Buscar por email",
            type: "input",
            placeholder: "Email",
            values: "",
            validate: {
              required: false
            },
            class: "col-md-6"
          },
          {
            id: "IdTextFind",
            model: "IdTextFind",
            type: "html",
            values: "",
            class: "col-md-12"
          }
        ],
        fields2: [],
        fields3: [],
        fields4: []
      }
    };
  }
};
</script>

<style>
.FormFormulario {
  background-color: #fff;
}

#FormFormularioOK .wizard-card-footer {
  display: none;
}

.totalform {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #ffffff;
}

.wizard-progress-with-circle {
  display: none !important;
}

.wizard-nav-pills,
.wizard-card-footer {
  margin-left: 10% !important;
  margin-right: 10% !important;
}

.vue-form-generator,
fieldset {
  display: contents;
}

.linkref {
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}

#div_IdICFESText {
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -20px;
}

#div_IdAddressNumTxt,
#div_IdAddressRefTxt {
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}

.linkref a {
  color: #f2a900 !important;
}

.noShow {
  display: none;
}

#div_IdTermiCondi .titleRef,
#div_IdHomolo .titleRef {
  color: #ffffff;
  margin-top: 10px;
}

.titleRefSumary {
  font-weight: bold;
  text-transform: uppercase;
  text-decoration-line: underline;
  margin-top: 20px;
  margin-bottom: 20px;
}

.titleSumary {
  font-weight: bold;
}

.listSumary {
  font-size: 13px;
}
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.active
{
  color: #222;
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}
.detalleAddress .is-invalid-form {
  display: none;
}

#sum_IdOperator,
#sum_IdICFESText {
  display: none;
}

.botonData {
  margin-right: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}

@media(min-width: 1024px)
{
  .FormFormulario {
  margin: 10px auto;
  width: 800px;
}
}

</style>
